import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export class TestingConstants {
    static TEXT_SUCCESS: string = UIStyleConstants.GREEN_COLOR;
    static TEXT_FAIL: string = UIStyleConstants.RED_COLOR;

    static BORDER_SUCCESS: string = UIStyleConstants.GREEN_COLOR;
    static BORDER_FAIL: string = UIStyleConstants.RED_COLOR;

    static BORDER_PASSED: string = UIStyleConstants.GREEN_COLOR;

    static BACKGROUND_SUCCESS: string = UIStyleConstants.GREEN_VERY_LIGHT_COLOR;
    static BACKGROUND_FAIL: string = UIStyleConstants.RED_VERY_LIGHT_COLOR;
}
